// extracted by mini-css-extract-plugin
module.exports = {"typeOfUploadButtons":"file-select-in-modal_typeOfUploadButtons__2_YRy","typeOfUploadButton":"file-select-in-modal_typeOfUploadButton__3Aw9G"};